import { AuthBindings } from "@refinedev/core";

// 複数アカウントの認証情報を取得
const AUTH_CREDENTIALS = [
  {
    username: import.meta.env.VITE_AUTH_USERNAME_1,
    password: import.meta.env.VITE_AUTH_PASSWORD_1,
  },
  {
    username: import.meta.env.VITE_AUTH_USERNAME_2,
    password: import.meta.env.VITE_AUTH_PASSWORD_2,
  },
];

export const authProvider: AuthBindings = {
  login: async ({ email, password }) => {
    console.log('Login attempt:', {
      inputEmail: email,
      inputPassword: password,
      availableUsernames: AUTH_CREDENTIALS.map(cred => cred.username),
    });
    
    // Debug: Log exact credential comparison details
    AUTH_CREDENTIALS.forEach((cred, index) => {
      console.log(`Credential check ${index + 1}:`, {
        storedUsername: cred.username,
        storedPassword: cred.password,
        usernameMatch: cred.username === email,
        passwordMatch: cred.password === password,
        fullMatch: cred.username === email && cred.password === password
      });
    });
    // いずれかの認証情報と一致するかチェック
    const isValidCredentials = AUTH_CREDENTIALS.some(
      (cred) => cred.username === email && cred.password === password
    );

    if (isValidCredentials) {
      localStorage.setItem('auth', 'true');
      return {
        success: true,
        redirectTo: "/",
      };
    }

    return {
      success: false,
      error: new Error('メールアドレスまたはパスワードが正しくありません'),
    };
  },

  logout: async () => {
    localStorage.removeItem('auth');
    return {
      success: true,
      redirectTo: "/login",
    };
  },

  check: async () => {
    const auth = localStorage.getItem('auth');
    if (auth === 'true') {
      return {
        authenticated: true,
      };
    }

    return {
      authenticated: false,
      redirectTo: '/login',
    };
  },

  getPermissions: async () => {
    return ['admin'];
  },

  getIdentity: async () => {
    const auth = localStorage.getItem('auth');
    if (auth === 'true') {
      return {
        id: 1,
        name: 'KYC管理者',
        avatar: '/admin-profile.png',
      };
    }
    return null;
  },
  onError: async (error) => {
    console.error(error);
    return { error };
  },
};
